import type { AbilityConfigMap } from '@efdigital/ll-addon-auth/types/abilities';

/**
 * Type-safe ability names for ll-xceed-v2.
 *
 * Defines all areas of the application that require permission checks.
 * Each ability maps to specific JWT rights in the user's ID token ('https://va/r').
 *
 * Naming Convention:
 * - Base abilities (e.g., 'programs') - View access to a feature area
 * - Action abilities (e.g., 'programs:create') - Specific actions within that area
 */
export type XceedV2AbilityName = 'coachee' | 'coach';

/**
 * Ability configuration for ll-xceed-v2.
 *
 * Maps ability names to required JWT rights at each access level.
 * Rights come from Azure AD B2C token claim 'https://va/r'.
 *
 * Access Levels:
 * - viewer: Read-only access (requires read:* rights)
 * - editor: Modify access (requires edit:* rights)
 * - fullcontrol: Administrative access (requires manage:* or purge:* rights)
 *
 * Security Model:
 * - Undefined levels or empty arrays = access denied (secure by default)
 * - All listed rights must be present (AND logic, not OR)
 * - Levels resolve from highest to lowest (fullcontrol → editor → viewer)
 *
 * @see {@link app/services/ability.ts} for usage examples
 */
export const ABILITIES: AbilityConfigMap = {
  coachee: {
    rights: {
      viewer: ['read:coaches'],
    },
  },

  coach: {
    rights: {
      viewer: ['read-my:coachees'],
    },
  },
};
